import { FormattedMessage } from 'react-intl'
import TravelDatepicker from '../../helpers/TravelDatepicker'

import styles from './scheduleHeader.module.scss'
import filterStyles from '../ActivityFilters.module.scss'
import cx from 'classnames'

export const buttons = [
  {
    title: <FormattedMessage id='all' defaultMessage='All' />,
    type: 'all',
    icon: 'icon-check-all',
  },
  {
    title: <FormattedMessage id='diving' defaultMessage='Diving' />,
    type: 'dive-trips',
    icon: 'icon-diver',
    product: 20,
  },
  {
    title: <FormattedMessage id='courses' defaultMessage='Courses' />,
    type: 'courses',
    icon: 'icon-course',
    product: 30,
  },
  {
    title: <FormattedMessage id='snorkeling' defaultMessage='Snorkeling' />,
    type: 'snorkelling',
    icon: 'icon-snorkeling',
  },
  {
    title: <FormattedMessage id='social' defaultMessage='Social' />,
    type: 'social-events',
    icon: 'icon-champagne',
  },
  {
    title: <FormattedMessage id='conservation' defaultMessage='Conservation' />,
    type: 'conservation',
    icon: 'icon-conservation',
  },
]
export default function ScheduleHeaderDSL({
  selectedType,
  onTypeChange,
  onDateChange,
  dateFrom,
}) {
  return (
    <div className={styles.scheduleHeader}>
      <div className={styles.toggleButtons}>
        {buttons.map((item) => {
          const onClick = () => onTypeChange(item.type)
          return (
            <button
              id={`schedule-btn-${item.type}`}
              key={item.type}
              className={cx(filterStyles.filterButton, {
                [filterStyles.active]: item.type === selectedType,
              })}
              onClick={onClick}
            >
              {item.title}
            </button>
          )
        })}
      </div>
      <div className={styles.calendar}>
        <TravelDatepicker
          callback={onDateChange}
          withIcon
          className={cx('travel-datepicker', styles.travelDatepicker)}
          dateFrom={dateFrom}
          isSchedule
        />
      </div>
    </div>
  )
}
